import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ServiceCard from "../components/ServiceCard";
import TestimonialCard from "../components/TestimonialCard";

function Home() {
  const { t } = useTranslation();

  const services = t("servicesList", { returnObjects: true });
  const testimonials = t("testimonialsList", { returnObjects: true });

  return (
    <div className="page home-page">
      
      {/* ===== STICKY PROMPT BAR ===== */}
      <div style={{
        position: "sticky",
        top: "80px",           // Aligns exactly below a standard 80px Nav Bar
        left: "0",
        width: "100%",
        backgroundColor: "#0d7a5f", 
        color: "white",
        textAlign: "center",
        padding: "12px 0",
        zIndex: "999",         
        fontWeight: "bold",
        fontSize: "0.9rem",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "10px",
        boxShadow: "0 2px 10px rgba(0,0,0,0.1)"
      }}>
        <span>💊 {t("home.needMedicine", "Special Volume Pricing")}</span>
        <Link 
          to="/services" 
          style={{
            backgroundColor: "#fff",
            color: "#0d7a5f",
            padding: "5px 15px",
            borderRadius: "20px",
            textDecoration: "none",
            fontSize: "0.8rem",
            fontWeight: "800",
            textTransform: "uppercase"
          }}
        >
          {t("home.buyNow", "Buy Now")}
        </Link>
      </div>

      {/* ===== HERO SECTION ===== */}
      {/* Increased padding to 100px to prevent the distributor tag from being cut off */}
      <section className="hero" style={{ paddingTop: "100px" }}>
        <div className="glow glow-1"></div>
        <div className="glow glow-2"></div>

        <div className="hero-badge">{t("hero.badge")}</div>
        <h1>{t("hero.title")}<br /><span>{t("hero.subtitle")}</span></h1>
        <p className="hero-text">
          {t("hero.text")}
        </p>

        <div className="hero-buttons">
          <Link to="/contact" className="btn-primary">
            {t("hero.inquireNow")}
          </Link>
          <Link to="/about" className="btn-secondary">{t("hero.learnMore")}</Link>
        </div>
      </section>

      {/* ===== SERVICES PREVIEW ===== */}
      <section className="section-block">
        <div className="container">
          <div className="section-header">
            <div className="section-label">{t("home.whatWeDistribute")}</div>
            <h2>{t("home.ourProducts")}</h2>
          </div>

          <div className="services-grid">
            {Array.isArray(services) && services.slice(0, 3).map((service) => (
              <ServiceCard key={service.id} {...service} />
            ))}
          </div>

          <div className="center-btn">
            <Link to="/services" className="btn-primary">{t("home.viewAllProducts")}</Link>
          </div>
        </div>
      </section>

      {/* ===== TESTIMONIALS PREVIEW ===== */}
      <section className="section-block">
        <div className="container">
          <div className="section-header">
            <div className="section-label">{t("home.whatPeopleSay")}</div>
            <h2>{t("home.testimonials")}</h2>
          </div>

          <div className="testimonials-grid">
            {Array.isArray(testimonials) && testimonials.slice(0, 3).map((test) => (
              <TestimonialCard key={test.id} {...test} />
            ))}
          </div>

          <div className="center-btn">
            <Link to="/testimonials" className="btn-primary">{t("home.readMoreReviews")}</Link>
          </div>
        </div>
      </section>

      {/* ===== CTA BANNER ===== */}
      <section className="cta-banner">
        <div className="container">
          <h2>{t("cta.title")}</h2>
          <p>{t("cta.text")}</p>
          <Link to="/contact" className="btn-primary">{t("cta.button")}</Link>
        </div>
      </section>
    </div>
  );
}

export default Home;